// Immutable deep-set. Returns a shallow-cloned copy of `obj` with `path` set to `value`, creating
// intermediate objects as needed. Behaviour-equivalent to the hand-rolled nested-spread updater
//   ({ ...prev, A: { ...prev.A, B: { ...prev.A?.B, FIELD: value } } })
// but collapsed to a single call: setIn(prev, ['A', 'B', 'FIELD'], value). Use inside a React
// setState updater: setData(prev => setIn(prev, [...path], value)).
export function setIn(obj: any, path: (string | number)[], value: any): any {
  if (path.length === 0) return value;
  const [head, ...rest] = path;
  const base = obj && typeof obj === 'object' ? obj : {};
  return { ...base, [head]: setIn(base[head], rest, value) };
}
